import "./style.css"

const Modal = ({ isOpen, onClose, children }) => {
    return (
        <>
            {isOpen && (
                <div className="modal-overlay-plan" onClick={onClose}>
                    <div
                        className="modal-content-modal-plan text-center"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {children}
                    </div>
                </div>
            )}
        </>
    );
};

const Plans = ({ isModalOpen, justCloseIt }) => {
    return (
        <div>
            <Modal isOpen={isModalOpen}>
                <div className="scrollable-modal-content-plan position-relative" >

                    <p
                        style={{
                            position: "absolute",
                            right: 12,
                            width: "12px",
                            top: "10px",
                            height: "12px",
                            cursor: "pointer",
                        }}
                        onClick={justCloseIt}
                    >
                        X
                    </p>

                    <b className="plan_main_heading">Pick the plan that works for you</b>
                    <p className="plan_main_subHeading">No contracts cancel at any time, 12-month ROI Guarantee
                    </p>
                    <div className="plans_box">
                        <div className="first_plan">
                            <div className="first_plan_content">
                                <p>Accounts</p>
                                <p>Price per call</p>
                                <p>Secure data storage</p>
                                <p>Earn from AI</p>
                                <p>Create Assistants </p>
                                <p>Add to Workflows</p>
                            </div>
                        </div>

                        <div className="second_plan">
                            <span className="second_plan_content_subHeading">GHL Starter AI</span>
                            <h1 className="second_plan_content_heading">PAYG</h1>
                            <button className="second_plan_content_btn">Get Started</button>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>Agency Only</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>$0.15</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>250MB</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>No</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>No</p>
                            <p className="second_plan_content_content">No</p>
                        </div>

                        <div className="second_plan">

                            <div className="plan_Recommended">
                                Recommended
                            </div>

                            <span className="second_plan_content_subHeading">GHL Starter AI</span>
                            <h1 className="second_plan_content_heading">£127</h1>
                            <button className="second_plan_content_btn">Get Started</button>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>20 sub-accounts</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>$0.06</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>1GB</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>Yes</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>Yes</p>
                            <p className="second_plan_content_content">Yes</p>
                        </div>

                        <div className="second_plan">
                            <span className="second_plan_content_subHeading">GHL Starter AI</span>
                            <h1 className="second_plan_content_heading">£597</h1>
                            <button className="second_plan_content_btn">Get Started</button>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>Unlimited</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>$0.035</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>10GB</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>Yes</p>
                            <p className="second_plan_content_content" style={{ borderBottom: "1px solid #E5E5E5" }}>Yes</p>
                            <p className="second_plan_content_content">Yes</p>
                        </div>
                    </div>

                </div>
            </Modal>
        </div>
    );
};

export default Plans